module.exports = __webpack_public_path__ + "img/full0-min.4973f4e8.png";